import { isWithinInterval } from 'date-fns';
import { RailsSale } from '~/typings/services/rails/sales';
import { RailsV2Session } from '~/typings/services/rails/session';

// TODO Put this file in a better place

export function isSaleBuySide(sale?: RailsSale) {
  return sale
    ? isWithinInterval(Date.now(), {
        start: new Date(sale.started_at),
        end: new Date(sale.ended_at),
      })
    : false;
}

export function isSaleSellSide(sale?: RailsSale) {
  return sale
    ? isWithinInterval(Date.now(), {
        start: new Date(sale.opened_at),
        end: new Date(sale.ended_at),
      })
    : false;
}

export function shouldShowSaleBanner(
  sale?: RailsSale,
  loggedIn?: boolean,
  sessionUser?: RailsV2Session,
) {
  if (!sale) {
    return false;
  }

  const isBuySide = isSaleBuySide(sale);
  const isSellSide = isSaleSellSide(sale);

  if (isBuySide) {
    return true;
  }

  if (isSellSide && loggedIn && sessionUser) {
    return sessionUser.actions.includes('view_sale_banner');
  }

  return false;
}
